/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosButton } from "@components/elements/atoms";
import { CosmosRichText } from "@components/elements/atoms/rich-text";
import { richTextContentStyles } from "@components/elements/ref-sections/rich-text";
import { CosmosElementCkEditorTextCollapsibleFragment } from "@cosmos/hygraph-schema";
import { VStack } from "@panda/jsx";
import { useState, useCallback } from "react";

export interface CollapsibleRichTextProps extends CosmosElementCkEditorTextCollapsibleFragment {
	isGameMode?: boolean;
	className?: string;
}

export const CollapsibleRichText = ({
	ckText,
	defaultOpen = false,
	collapseButtonLabel,
	isGameMode,
	className,
}: CollapsibleRichTextProps): React.JSX.Element | null => {
	const [collapsed, setCollapsed] = useState(!defaultOpen);
	const toggle = useCallback(() => {
		setCollapsed(!collapsed);
	}, [collapsed, setCollapsed]);

	if (!ckText) return null;

	return (
		<VStack gap="eds.dimension.24" alignItems={"flex-start"} className={className || ""}>
			<CosmosButton
				size="lg"
				iconPosition="end"
				iconSize="sm"
				variant="secondary"
				onClick={toggle}
				icon={collapsed ? "ChevronDown" : "ChevronUp"}
			>
				{collapseButtonLabel || "Show"}
			</CosmosButton>
			{collapsed ? null : (
				<div className={richTextContentStyles}>
					<CosmosRichText html={ckText} isGameMode={isGameMode} />
				</div>
			)}
		</VStack>
	);
};
